<template>
  <div id="table">
    <table class="table">
      <tr>
        <td colspan="5" class="text-center">
          <span class="flag-icon" style="font-size: 120px;border:1px solid #eee;" :class="flagClass"></span>
          <div class="mt-2"><h2>{{ typeTitle }}</h2></div>
        </td>
      </tr>
      <tr>
        <td class="text-center">วันที่</td>
        <td colspan="4">
          <flat-pickr :config="{time_24hr: true, dateFormat: 'Y-m-d'}" v-model="lotto.lotto_date" placeholder="วันที่" />
        </td>
      </tr>
      <tr>
        <td class="text-center">รอบ</td>
        <td colspan="4">
          <v-select v-model="round" :options="roundOptions" @input="setSelected"></v-select>
        </td>
      </tr>
      <tr>
        <td class="text-center">เวลาออกผล</td>
        <td colspan="4">
          <!--<flat-pickr :config="{enableTime: true, enableSeconds: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S'}" v-model="lotto.show_result" placeholder="เวลาออกผล" />
          <div v-if="invalidStartSpin" class="text-danger text-sm">กรุณาเลือกเวลาออกผล</div>-->
          <input type="text" class="vs-inputx vs-input--input normal" name="show_result" v-model="lotto.show_result" readonly disabled>
        </td>
      </tr>
      <tr>
        <td class="text-center">เลข 3 ตัว</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_1st" v-validate="'numeric|length:3'" data-vv-as="*" data-vv-validate-on="blur" maxlength="3" v-model="lotto.results.prize_1st">
          <div class="text-danger text-sm">{{ errors.first('prize_1st') }}</div>
        </td>
      </tr>
      <tr>
        <td class="text-center">เลข 2 ตัว</td>
        <td>
          <input type="text" class="vs-inputx vs-input--input normal text-center" name="prize_2nd" v-validate="'numeric|length:2'" data-vv-as="*" data-vv-validate-on="blur" maxlength="2" v-model="lotto.results.prize_2nd">
          <div class="text-danger text-sm">{{ errors.first('prize_2nd') }}</div>
        </td>
      </tr>
      <tr>
        <td colspan="6">
          <vs-button class="vs-xs-12 float-right" color="success" @click="save">Save</vs-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import moment from "@/moment.js"

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import {lottoConfigs} from "@/configs/lotto.config.js"

import vSelect from 'vue-select'

//import 'vue-select/dist/vue-select.css';

export default {
  name: 'ResultForm',
  components: {
    flatPickr,
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lotto: this.data,
      invalidStartSpin: false,
      round: {}
    }
  },
  computed: {
    lottoType() {
      return this.lotto.lotto_type
    },
    watchData() {
      return this.data.round
    },
    config() {
      let config = lottoConfigs.find((config)=>{
        return config.code === this.$route.params.lottoType
      })
      if(config) {
        return config
      }else{
        return false
      }
    },
    flagClass() {
      if(this.config) {
        return this.config.flag
      }else{
        return null
      }
    },
    typeTitle() {
      if(this.config) {
        return this.config.name
      }else{
        return this.$route.params.lottoType
      }
    },
    roundOptions() {
      return this.config.rounds.map((round)=>{
        return {
          label: round.rname,
          code: round.rcode
        }
      })
    }
  },
  watch: {
    watchData() {
      this.setData()
    },
    'lotto.lotto_date'() {
      this.setData()
    }
  },
  methods: {
    setData() {
      this.lotto = this.data
      let round = this.config.rounds.find((round)=>{
        return round.rcode === this.data.round
      })
      this.round = {
        label: round.rname,
        code: round.rcode
      }
      this.setShowtime(round)
    },
    setShowtime(round) {
      if(this.data.lotto_id === null) {
        this.lotto.show_result = moment(this.data.lotto_date).format("YYYY-MM-DD") + ' ' + round.time;
      }
    },
    setSelected(val) {
      this.lotto.round = val.code
      let round = this.config.rounds.find((round)=>{
        return round.rcode === val.code
      })
      this.setShowtime(round)
    },
    save() {
      this.$validator.validate().then(valid => {
        this.invalidStartSpin = this.lotto.show_result === ''
        if (valid && !this.invalidStartSpin) {
          this.$emit('save', this.lotto)
        }
      })
    }
  },
  created() {
    this.setData()
  }
}

</script>
<style lang="scss">
#table {
  .table {
    width: auto;
    background-color: #FFF;
    border-collapse: collapse;
  }

  .table {
    tr {
      td {
        &:first-child {
          width: 200px;
          font-weight: bold;
        }

        .vs-input--input {
          width: auto;
        }

        input {
          //border: 1px solid rgba(0, 0, 0, 0.2);
          color: blue;
        }

        .vdp-datepicker input {
          width: auto;
        }
      }

      td {
        padding: 16px 8px;
        border: 1px solid #DDDDDD;
        border-collapse: collapse;
      }

      .no-boder-r {
        border-right: 0;
      }

      .no-boder-l {
        border-left: 0;
      }

      .no-boder-t {
        border-top: 0;
      }

      .no-boder-b {
        border-bottom: 0;
      }
    }
  }

  .text-center {
    text-align: center;
  }
}

</style>
